<div class="flexic">
  <span class="fl text-sm mr-2">{{ text | translate }}</span>
  <a3l-ui-spinner [color]="color" size="20"></a3l-ui-spinner>
</div>
